export default "__VITE_ASSET__65d5cf4b__"